import { render, staticRenderFns } from "./messageItem.vue?vue&type=template&id=43c0c9a5&scoped=true&"
import script from "./messageItem.vue?vue&type=script&lang=js&"
export * from "./messageItem.vue?vue&type=script&lang=js&"
import style0 from "./messageItem.vue?vue&type=style&index=0&id=43c0c9a5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43c0c9a5",
  null
  
)

export default component.exports